var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"overview"},[_c('b-row',[_c('span',{staticClass:"label"},[_vm._v("Description :")]),(_vm.overview)?_c('p',[_vm._v(_vm._s(_vm.overview))]):_c('span',[_vm._v("Pas de description disponible")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }